export default "__VITE_PUBLIC_ASSET__092ceed4__"